import React from 'react'
import PropTypes from 'prop-types'

import { requestWithAuth } from 'shared/utilities/authUtils'
import { makeRequest } from 'Store/Request/actions'
import { getRequestType } from 'Store/AppState/selectors'

import LookupShow from 'Lookup/LookupShow'
import InnerLoader from 'shared/components/Loaders/InnerLoader'
import { propTypes } from 'react-bootstrap/esm/Image'

class LookupRequestsWrapper extends React.Component {
  constructor(props) {
    super(props)

    this.loadRequests = this.loadRequests.bind(this)
    this.state = {
      hasLoadedRequests: false
    }

    // Only load requests if we have them and haven't loaded them yet
    if (props.appState.requests.length && !this.state.hasLoadedRequests) {
      this.loadRequests(props.appState.requests)
      this.setState({ hasLoadedRequests: true })
    }
  }

  componentDidUpdate(prevProps) {
    // Only load requests if they've actually changed and we haven't loaded them yet
    if (
      prevProps.appState.requests !== this.props.appState.requests &&
      this.props.appState.requests.length > 0 &&
      !this.state.hasLoadedRequests
    ) {
      this.loadRequests(this.props.appState.requests)
      this.setState({ hasLoadedRequests: true })
    }
  }

  loadRequests(requests = []) {
    // Prevent duplicate requests by checking if we've already processed these
    if (requests.length === 0) return

    requests.forEach(request => {
      this.props.dispatch(requestWithAuth(makeRequest(request)))
    })
  }

  render() {
    return this.props.appState.requests.length ? (
      <LookupShow
        appState={this.props.appState}
        errorstate={this.props.errorState}
        loadingState={this.props.loadingState}
        lookupRequests={getRequestType(this.props.appState.requests, 'LOOKUP_FILTER')}
        loadingRequests={this.props.loading}
        profileRequest={getRequestType(this.props.appState.requests, 'LOOKUP_PROFILE')[0]}
        propertyResult={this.props.propertyResult}
        {...this.props}
        propertyError={this.props.propertyError}
      />
    ) : (
      <InnerLoader />
    )
  }
}

LookupRequestsWrapper.propTypes = {
  appState: PropTypes.object,
  dispatch: PropTypes.func,
  loadingState: PropTypes.object,
  propertyResult: PropTypes.object,
  loggedIn: PropTypes.bool,
  userBookmarks: PropTypes.object
}

export default LookupRequestsWrapper
